import React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import "./TheParentDashboard.css";
import Subjects from "./imageFiles/Subjects.png";

const getStatusClass = (status) => {
  switch (status) {
    case "Assigned":
      return "status-pill assigned";
    case "On Progress":
      return "status-pill progress";
    case "Finished":
      return "status-pill finished";
    default:
      return "status-pill";
  }
};

export default function StudentPapersStatus({ papers, parent_dashboard_initial_loading }) {
  return (
    <div className="student-papers-status">
      {!parent_dashboard_initial_loading && papers.length>0 ?(
        papers?.map((paper, index) => (
          <div className="paper-row" key={index}>
              <div className="col-10 subject-info px-0">
                <div className="col-8 subject-info px-0">
              <img
                src={Subjects}
                className="paper-icon me-2"
                alt="paper-icon"
              />
              <span className="paper-title">{paper?.assess_name || "N/A"}</span>
              </div>
              <div className="col-4 px-0">
            <div className="d-flex align-items-center">
              <AccessTimeIcon fontSize="small" className="me-1" />
              <span className="time-text">{paper?.time}</span>
            </div>
              </div>            
            </div>
            <div className="col-2">
            <div className={getStatusClass(paper.candidate_status)}>{paper.candidate_status || "N/A"}</div>
            </div>
            <div></div>
          </div>
      ))
    ):(
      parent_dashboard_initial_loading?(
        <>Loading...</>
      ):(
        <>No Papers...</>
      )
    )}
    </div>
  );
}
